/**
 * setup-api-base.js
 * Mar 2, 2026 — CRITICAL BOOTSTRAP MODULE
 *
 * This file MUST be imported before any other application module in
 * `src/index.js` so that `window.__WR_API_BASE__` is defined before any
 * downstream module reads it at module-load time.
 *
 * Root cause it fixes:
 *   Several modules (useGeneration, useTemplates, RoleSelector, ~20 total)
 *   declare `const API = \`${window.__WR_API_BASE__}/api\`` at module top
 *   level. Because ES module top-level code runs in dependency order, App's
 *   deep imports evaluated BEFORE index.js reached the assignment line
 *   (which lived AFTER `import App from '@/App'`). The literal became
 *   "undefined/api" → 404s, generation failures, blank output tabs.
 *
 * Provider spent an entire back-charting shift chasing this — never again.
 * Setting the global HERE (in a module imported first) guarantees the
 * value is present before any component's top-level `const API = ...` runs.
 */
if (typeof window !== 'undefined') {
  const env = process.env.REACT_APP_BACKEND_URL || '';
  const localHosts = ['localhost', '127.0.0.1', '0.0.0.0'];

  window.__WR_API_BASE__ = (() => {
    // Localhost/dev: honor the compile-time env var (usually points at 8001
    // via CRA proxy or docker network).
    try {
      if (localHosts.includes(window.location.hostname)) return env;
    } catch (_) { /* SSR guard */ }
    // Anywhere else (preview, prod, alt-domain fallback): use the same
    // origin the user opened the app on. This lets both writerightpcm.com
    // and pcm-write-time-1.emergent.host reach their respective backends
    // through the platform's ingress without a rebuild.
    try {
      return window.location.origin;
    } catch (_) {
      return env; // last-ditch fallback
    }
  })();
}

export {};  // ensure this is treated as a module by CRA
